var DEFAULT_FIELD_SIZE = 12;
export var getFieldSize = function getFieldSize(field) {
  var _field$size, _field$size2, _field$size3, _field$size4, _field$size5, _field$size6;
  return {
    xs: ((_field$size = field.size) === null || _field$size === void 0 ? void 0 : _field$size.xs) || DEFAULT_FIELD_SIZE,
    m: (_field$size2 = field.size) === null || _field$size2 === void 0 ? void 0 : _field$size2.m,
    l: (_field$size3 = field.size) === null || _field$size3 === void 0 ? void 0 : _field$size3.l,
    xsOffsetRight: (_field$size4 = field.size) === null || _field$size4 === void 0 ? void 0 : _field$size4.xsOffsetRight,
    mOffsetRight: (_field$size5 = field.size) === null || _field$size5 === void 0 ? void 0 : _field$size5.mOffsetRight,
    lOffsetRight: (_field$size6 = field.size) === null || _field$size6 === void 0 ? void 0 : _field$size6.lOffsetRight
  };
};